import { createApiClient, responseData } from '#lib/api/client.js';
import type { operations } from '#lib/api/generated/schema.js';

export type EditionsGalleryItemsParams =
	operations['getEditionsGalleryItems']['parameters']['query'];

// Shared between the universal load (cache seeding, prefetch) and the page
// component's infinite query — the two must hash identically for the seeded
// first page to be found.
export const editionsGalleryItemsQueryKey = (
	params: EditionsGalleryItemsParams
) => ['editions-gallery-items', params];

export const getEditionsGalleryPage = async (
	fetchFn: typeof globalThis.fetch | undefined
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/editions-gallery')
	);

export const getEditionsSeriesPage = async (
	fetchFn: typeof globalThis.fetch | undefined,
	slug: string
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/editions-series/{slug}',
			{ params: { path: { slug } } }
		)
	);

export const getEditionsGalleryItems = async (
	fetchFn: typeof globalThis.fetch | undefined,
	query: EditionsGalleryItemsParams
) =>
	responseData(
		await createApiClient(fetchFn).GET(
			'/website-api/pages/editions-gallery-items',
			{ params: { query } }
		)
	);
